import { EventEmitter } from "eventemitter3";

export interface IssueListEmitterParams {
    refresh: () => unknown;
}

export const IssueListEmitter = new EventEmitter<IssueListEmitterParams>();
